













import { defineComponent, ref } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "FaqItem",
  components: { BaseIconButton },
  props: {
    question: { type: String, required: true },
    answer: { type: String, required: true },
  },
  setup() {
    const showAnswer = ref(false);

    return {
      showAnswer,
    };
  },
});
